function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.343 21.298V3.185h13.318v18.759l.342.547 11.014 17.621c1.788 2.861-.269 6.573-3.643 6.573H12.63c-3.374 0-5.43-3.712-3.643-6.573l11.014-17.621.342-.547v-.646z",
  stroke: "#1FA956",
  strokeWidth: 4.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 15.25,
  y: 2.185,
  width: 23.5,
  height: 2.5,
  rx: 1.25,
  stroke: "#1FA956",
  strokeWidth: 2.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.273 43.48l7.637-10.455h26.182l7.636 9.364-3.273 4.364H10.637L6.273 43.48zm18.545-3.273a3.273 3.273 0 11-6.545 0 3.273 3.273 0 016.545 0zm7.727 1.273a2.182 2.182 0 100-4.364 2.182 2.182 0 000 4.364z",
  fill: "#1FA956"
});

function SvgImgScience(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTQiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1NCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjM0MyAyMS4yOTgyVjMuMTg0NTdIMzMuNjYxMlYyMS4yOTgyVjIxLjk0MzVMMzQuMDAzMiAyMi40OTA3TDQ1LjAxNjkgNDAuMTEyNUM0Ni44MDUgNDIuOTczNSA0NC43NDgxIDQ2LjY4NDYgNDEuMzc0MyA0Ni42ODQ2SDEyLjYyOTlDOS4yNTYxMyA0Ni42ODQ2IDcuMTk5MjggNDIuOTczNSA4Ljk4NzQgNDAuMTEyNUwyMC4wMDEgMjIuNDkwN0wyMC4zNDMgMjEuOTQzNVYyMS4yOTgyWiIgc3Ryb2tlPSIjMUZBOTU2IiBzdHJva2Utd2lkdGg9IjQuNSIvPgo8cmVjdCB4PSIxNS4yNSIgeT0iMi4xODQ1NyIgd2lkdGg9IjIzLjUiIGhlaWdodD0iMi41IiByeD0iMS4yNSIgc3Ryb2tlPSIjMUZBOTU2IiBzdHJva2Utd2lkdGg9IjIuNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuMjczNDQgNDMuNDc5OUwxMy45MDk4IDMzLjAyNTRINDAuMDkxNkw0Ny43MjggNDIuMzg5TDQ0LjQ1NTMgNDYuNzUyN0gxMC42MzcxTDYuMjczNDQgNDMuNDc5OVpNMjQuODE4MiA0MC4yMDcyQzI0LjgxODIgNDIuMDE0NiAyMy4zNTI5IDQzLjQ3OTkgMjEuNTQ1NSA0My40Nzk5QzE5LjczOCA0My40Nzk5IDE4LjI3MjcgNDIuMDE0NiAxOC4yNzI3IDQwLjIwNzJDMTguMjcyNyAzOC4zOTk3IDE5LjczOCAzNi45MzQ0IDIxLjU0NTUgMzYuOTM0NEMyMy4zNTI5IDM2LjkzNDQgMjQuODE4MiAzOC4zOTk3IDI0LjgxODIgNDAuMjA3MlpNMzIuNTQ1NCA0MS40Nzk4QzMzLjc1MDMgNDEuNDc5OCAzNC43MjcyIDQwLjUwMyAzNC43MjcyIDM5LjI5OEMzNC43MjcyIDM4LjA5MyAzMy43NTAzIDM3LjExNjIgMzIuNTQ1NCAzNy4xMTYyQzMxLjM0MDQgMzcuMTE2MiAzMC4zNjM1IDM4LjA5MyAzMC4zNjM1IDM5LjI5OEMzMC4zNjM1IDQwLjUwMyAzMS4zNDA0IDQxLjQ3OTggMzIuNTQ1NCA0MS40Nzk4WiIgZmlsbD0iIzFGQTk1NiIvPgo8L3N2Zz4K";
export { SvgImgScience as ReactComponent };